<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5014)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5014)" />
    </g>
    <g clip-path="url(#clip0_3254_5014)">
      <path
        d="M23.6666 18C23.6666 14.318 20.6819 11.3333 16.9999 11.3333C13.3179 11.3333 10.3333 14.318 10.3333 18C10.3333 21.682 13.3179 24.6666 16.9999 24.6666"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M17.6665 11.3666C17.6665 11.3666 19.6665 14 19.6665 18M16.3332 24.6333C16.3332 24.6333 14.3332 22 14.3332 18C14.3332 14 16.3332 11.3666 16.3332 11.3666M10.7532 20.3333H16.9998M10.7532 15.6666H23.2465"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M23.5859 21.9446C23.9152 22.1473 23.8946 22.64 23.5559 22.6786L21.8446 22.8726L21.0772 24.414C20.9252 24.72 20.4552 24.57 20.3772 24.1913L19.5406 20.114C19.4746 19.794 19.7626 19.5926 20.0406 19.764L23.5859 21.9446Z"
        stroke="white" />
    </g>
    <defs>
      <filter id="filter0_d_3254_5014"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.803922 0 0 0 0 0.905882 0 0 0 0 0.0352941 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5014" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5014" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5014"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#A6A922" />
        <stop offset="1" stop-color="#DBFF00" />
      </linearGradient>
      <clipPath id="clip0_3254_5014">
        <rect width="16" height="16" fill="white" transform="translate(9 10)" />
      </clipPath>
    </defs>
  </svg>
</template>
